<div class="mb-8 text-left text-lg font-medium text-neutral-gray70">
  {{ message | translate }}
</div>
<div *ngIf="showInput" class="mb-10" style="margin-right: 24px">
  <input
    [(ngModel)]="inputValue"
    [placeholder]="inputPlaceholder | translate"
    class="w-full rounded-lg border border-neutral-gray30 px-4 py-2 text-base text-neutral-gray70"
    type="email"
    autocomplete="off"
    (blur)="onInputBlur()" />
  <div *ngIf="inputTouched && !isEmailValid" class="mt-2 text-sm text-functional-error">
    {{ 'modules.scores.form.errors.email_invalid' | translate }}
  </div>
</div>
<div class="flex justify-end gap-4">
  <button
    (click)="cancel()"
    class="rounded-lg border border-neutral-gray30 bg-white px-6 py-2 text-base text-neutral-gray70 hover:bg-neutral-gray10 focus:outline-none">
    {{ cancelLabel | translate }}
  </button>
  <button
    (click)="confirm()"
    [disabled]="showInput && !isEmailValid"
    class="rounded-lg bg-primary-90 px-6 py-2 text-base font-medium text-white focus:outline-none disabled:opacity-50"
    [ngClass]="{
      'cursor-not-allowed': showInput && !isEmailValid,
      'cursor-pointer': !showInput || isEmailValid
    }">
    {{ confirmLabel | translate }}
  </button>
</div>
